import { SkeletonBox, Space } from '@billy/design-system'

import * as Styled from './styles'

const CARD_COUNT = 3

export const BankAccountsSkeleton = () => {
  return (
    <>
      <Styled.BalanceWrapper>
        <SkeletonBox height={20} width={150} />
        <SkeletonBox height={48} width={220} />
      </Styled.BalanceWrapper>

      <Styled.SkeletonGridContainer>
        {Array.from({ length: CARD_COUNT }).map((_, index) => (
          <SkeletonBox key={index} height={200} fullWidth />
        ))}
      </Styled.SkeletonGridContainer>

      <Space size="s16" />

      <SkeletonBox height={280} fullWidth />
    </>
  )
}
